// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_ue","wrapperDark":"e_ve","wrapperLight":"e_we"};